import styled from 'styled-components';

import {Input} from 'components/ui-kit/Input';
import {MaxWidthContainer} from 'components/ui-kit/MaxWidthContainer';
import {breakpoint, buttonReset, colors} from 'theme';

export const Root = styled(MaxWidthContainer)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    background-color: ${colors.background};
    padding-top: 19px;
    padding-bottom: 19px;

    @media print {
        display: none;
    }
`;

export const Title = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    flex: 1;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 16px;
    }

    > :first-child {
        display: inherit;
        margin-right: 12px;

        @media (min-width: ${breakpoint.desktop}) {
            display: none;
        }
    }
`;

export const GlobalSearch = styled(Input)`
    display: none;

    @media (min-width: ${breakpoint.desktop}) {
        display: inherit;
        flex: 1;

        input {
            width: 400px;
            height: 40px;
        }
    }
`;

export const AccountInfo = styled.div`
    display: none;

    @media (min-width: ${breakpoint.desktop}) {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
    }
`;

export const ProfileButton = styled.div`
    ${buttonReset};

    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;

    &:hover {
        text-decoration: underline;
    }

    > :first-of-type {
        margin-right: 10px;
    }
`;

export const Separator = styled.div`
    margin: 0 13px;
    width: 1px;
    height: 20px;
    background-color: ${colors.border};
`;

export const LeaveButton = styled.div`
    ${buttonReset};

    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
    color: ${colors.brandPrimary};

    &:hover {
        text-decoration: underline;
    }
`;

export const HeaderContent = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const SubInfo = styled.div`
    font-size: 10px;
    color: ${colors.textSecondary};
`;
